import ResourceService from "./resource.service";

class InsuranceCompaniesService extends ResourceService {
  static get resource() {
    return "insurance-company";
  }
}

export default InsuranceCompaniesService;
